module.exports = __webpack_public_path__ + "components/rewards/hike-and-ride/static/logo-2224a28755a915207b0e04de25226ed1.jpg";